// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"
import InvoiceLine from "./invoice-line.js"
import Order from "./order.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "credit_note_for_id": {
      "column": {
        "default": null,
        "name": "credit_note_for_id",
        "null": true,
        "type": "uuid"
      },
      "name": "credit_note_for_id",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "invoice_date": {
      "column": {
        "default": null,
        "name": "invoice_date",
        "null": true,
        "type": "date"
      },
      "name": "invoice_date",
      "selected_by_default": null,
      "translated": null
    },
    "invoice_type": {
      "column": {
        "default": "invoice",
        "name": "invoice_type",
        "null": false,
        "type": "string"
      },
      "name": "invoice_type",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "old_id": {
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      },
      "name": "old_id",
      "selected_by_default": null,
      "translated": null
    },
    "sales_order_number": {
      "column": {
        "default": null,
        "name": "sales_order_number",
        "null": true,
        "type": "string"
      },
      "name": "sales_order_number",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "translated_invoice_type": {
      "column": null,
      "name": "translated_invoice_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_resource_type": {
      "column": null,
      "name": "translated_resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "booked": {
      "column": null,
      "name": "booked",
      "selected_by_default": false,
      "translated": null
    },
    "credit_note_for_sales_order_number": {
      "column": null,
      "name": "credit_note_for_sales_order_number",
      "selected_by_default": false,
      "translated": null
    },
    "credit_note_id": {
      "column": null,
      "name": "credit_note_id",
      "selected_by_default": false,
      "translated": null
    },
    "credit_note_sales_order_number": {
      "column": null,
      "name": "credit_note_sales_order_number",
      "selected_by_default": false,
      "translated": null
    },
    "credited": {
      "column": null,
      "name": "credited",
      "selected_by_default": false,
      "translated": null
    },
    "total": {
      "column": null,
      "name": "total",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Invoice",
  "collectionKey": "invoices",
  "collectionName": "invoices",
  "i18nKey": "invoice",
  "camelizedLower": "invoice",
  "name": "Invoice",
  "nameDasherized": "invoice",
  "pluralName": "invoices",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "concerning_id",
      "name": "concerning",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "credit_note_for_id",
      "name": "credit_note",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "credit_note_for_id",
      "name": "credit_note_for",
      "macro": "belongs_to",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "InvoicePayment",
      "collectionName": "invoice_payments",
      "foreignKey": "invoice_id",
      "name": "invoice_payments",
      "macro": "has_many",
      "resource_name": "InvoicePayment",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "SubscriptionRenewalGeneration",
      "collectionName": "subscription_renewal_generations",
      "foreignKey": "subscription_renewal_generation_id",
      "name": "subscription_renewal_generations",
      "macro": "has_many",
      "resource_name": "SubscriptionRenewalGeneration",
      "through": "invoice_lines"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "concerning_id",
      "column": {
        "default": null,
        "name": "concerning_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "credit_note_for_id",
      "column": {
        "default": null,
        "name": "credit_note_for_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "invoice_date",
      "column": {
        "default": null,
        "name": "invoice_date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "invoice_type",
      "column": {
        "default": "invoice",
        "name": "invoice_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_concerning_id",
      "column": {
        "default": null,
        "name": "old_concerning_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_credit_note_for_id",
      "column": {
        "default": null,
        "name": "old_credit_note_for_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "order_id",
      "column": {
        "default": null,
        "name": "order_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "sales_order_number",
      "column": {
        "default": null,
        "name": "sales_order_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "id_begins_with"
    },
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "concerning_id",
      "name": "concerning",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "credit_note_for_id",
      "name": "credit_note_for",
      "macro": "belongs_to",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    }
  ],
  "paramKey": "invoice",
  "primaryKey": "id"
}

/** Frontend model for Invoice. */
export default class Invoice extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  creditNoteForId() {
    return this.readAttributeUnderscore("credit_note_for_id")
  }

  /** @returns {boolean} */
  hasCreditNoteForId() {
    const value = this.creditNoteForId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  invoiceDate() {
    return this.readAttributeUnderscore("invoice_date")
  }

  /** @returns {boolean} */
  hasInvoiceDate() {
    const value = this.invoiceDate()

    return this._isPresent(value)
  }

  /** @returns {string} */
  invoiceType() {
    return this.readAttributeUnderscore("invoice_type")
  }

  /** @returns {boolean} */
  hasInvoiceType() {
    const value = this.invoiceType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  oldId() {
    return this.readAttributeUnderscore("old_id")
  }

  /** @returns {boolean} */
  hasOldId() {
    const value = this.oldId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  salesOrderNumber() {
    return this.readAttributeUnderscore("sales_order_number")
  }

  /** @returns {boolean} */
  hasSalesOrderNumber() {
    const value = this.salesOrderNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedInvoiceType() {
    return this.readAttributeUnderscore("translated_invoice_type")
  }

  /** @returns {boolean} */
  hasTranslatedInvoiceType() {
    const value = this.translatedInvoiceType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedResourceType() {
    return this.readAttributeUnderscore("translated_resource_type")
  }

  /** @returns {boolean} */
  hasTranslatedResourceType() {
    const value = this.translatedResourceType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  booked() {
    return this.readAttributeUnderscore("booked")
  }

  /** @returns {boolean} */
  hasBooked() {
    const value = this.booked()

    return this._isPresent(value)
  }

  /** @returns {any} */
  creditNoteForSalesOrderNumber() {
    return this.readAttributeUnderscore("credit_note_for_sales_order_number")
  }

  /** @returns {boolean} */
  hasCreditNoteForSalesOrderNumber() {
    const value = this.creditNoteForSalesOrderNumber()

    return this._isPresent(value)
  }

  /** @returns {any} */
  creditNoteId() {
    return this.readAttributeUnderscore("credit_note_id")
  }

  /** @returns {boolean} */
  hasCreditNoteId() {
    const value = this.creditNoteId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  creditNoteSalesOrderNumber() {
    return this.readAttributeUnderscore("credit_note_sales_order_number")
  }

  /** @returns {boolean} */
  hasCreditNoteSalesOrderNumber() {
    const value = this.creditNoteSalesOrderNumber()

    return this._isPresent(value)
  }

  /** @returns {any} */
  credited() {
    return this.readAttributeUnderscore("credited")
  }

  /** @returns {boolean} */
  hasCredited() {
    const value = this.credited()

    return this._isPresent(value)
  }

  /** @returns {any} */
  total() {
    return this.readAttributeUnderscore("total")
  }

  /** @returns {boolean} */
  hasTotal() {
    const value = this.total()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static destroyOrSoftDelete(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "destroy_or_soft_delete",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceBookInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_book_in_business_central",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceCreateInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_create_in_business_central",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceCredit(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_credit",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceSyncInvoicePaymentsFromBambora(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_sync_invoice_payments_from_bambora",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceUpdateStateFromBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_update_state_from_business_central",
        collectionName: "invoices",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  bookInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "book_in_business_central",
        primaryKey: this.primaryKey(),
        collectionName: "invoices",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createCreditNoteFromInvoice(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_credit_note_from_invoice",
        primaryKey: this.primaryKey(),
        collectionName: "invoices",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_in_business_central",
        primaryKey: this.primaryKey(),
        collectionName: "invoices",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  concerning() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "concerning"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadConcerning() {
    if (!("concerningId" in this)) throw new Error("Foreign key method wasn't defined: concerningId")

    const id = this.concerningId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "concerning",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureConcerningLoaded() {
    return this.ensureAssociationLoaded("concerning")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./invoice.js").default | null} */
  creditNoteFor() {
    return this._readBelongsToReflection({modelClass: Invoice, reflectionName: "credit_note_for"})
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  loadCreditNoteFor() {
    if (!("creditNoteForId" in this)) throw new Error("Foreign key method wasn't defined: creditNoteForId")

    const id = this.creditNoteForId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "credit_note_for",
        model: this,
        modelClass: Invoice
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  ensureCreditNoteForLoaded() {
    return this.ensureAssociationLoaded("credit_note_for")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./invoice-line.js").default>} */
  invoiceLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["invoice_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "invoice_lines",
        model: this,
        modelClass: InvoiceLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-line.js").default>>} */
  loadInvoiceLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["invoice_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "invoice_lines",
        model: this,
        modelClass: InvoiceLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-line.js").default>>} */
  ensureInvoiceLinesLoaded() {
    return this.ensureAssociationLoaded("invoice_lines")
  }

  /** @returns {import("./order.js").default | null} */
  order() {
    return this._readBelongsToReflection({modelClass: Order, reflectionName: "order"})
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  loadOrder() {
    if (!("orderId" in this)) throw new Error("Foreign key method wasn't defined: orderId")

    const id = this.orderId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "order",
        model: this,
        modelClass: Order
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  ensureOrderLoaded() {
    return this.ensureAssociationLoaded("order")
  }
}
